// application
import enMessages from './messages/en';
import ruMessages from './messages/ru';

export default {
    en: enMessages,
    ru: ruMessages,
};
